var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { omitStyleProps } from '../../utils/props';
import { COLOR_SET_CLASSES, applyMargins } from '../../utils/tailwind';
import { useColorSet } from '../ThemeProvider/useColorSet';
import { useTheme } from '../ThemeProvider/useTheme';
import { SuperEllipseBadge } from './SuperEllipseBadge';
import { SuperEllipseIcon } from './SuperEllipseIcon';
import { SuperEllipseSvg } from './SuperEllipseSvg';
import { SuperEllipseText } from './SuperEllipseText';
import { superEllipse } from './styles';
const { base, childrenWrapper } = superEllipse();
export const SuperEllipse = (_a) => {
    var { size, withStroke, colorSet = 'default', invertedColor, defaultBackground, highlight, image, icon, text, badge, strokeColor, shadowElevation, iconProps, children, preserveAspectRatio, className } = _a, props = __rest(_a, ["size", "withStroke", "colorSet", "invertedColor", "defaultBackground", "highlight", "image", "icon", "text", "badge", "strokeColor", "shadowElevation", "iconProps", "children", "preserveAspectRatio", "className"]);
    const colors = useColorSet({
        colorSet,
        invertedColor,
    });
    const theme = useTheme();
    const invertColorsKey = invertedColor ? 'inverted' : 'default';
    const colorSetClasses = COLOR_SET_CLASSES[colorSet][invertColorsKey];
    return (_jsxs("div", Object.assign({}, omitStyleProps(props), { className: base({
            size,
            className: [applyMargins(props), className],
        }), children: [_jsx(SuperEllipseSvg, { image: icon ? '' : image, backgroundColor: defaultBackground ? theme.colors.background.default : colors.background, withStroke: withStroke || Boolean(strokeColor), strokeColor: strokeColor, highlight: highlight, shadowElevation: shadowElevation, preserveAspectRatio: preserveAspectRatio }), _jsxs("div", { className: childrenWrapper(), children: [_jsx(SuperEllipseIcon, Object.assign({ size: size, icon: icon }, iconProps, { className: colorSetClasses.icon })), _jsx(SuperEllipseBadge, { size: size, badge: badge }), !(icon || image) && _jsx(SuperEllipseText, { size: size, text: text, className: colorSetClasses.content }), !(icon || image || text) && children] })] })));
};
